import styled from 'styled-components';

import { GridContainer, GridItem } from '@xing-com/grid';
import { mediaSmallOrTiny } from '@xing-com/layout-tokens';

export const SectionGridContainer = styled(GridContainer)`
  max-width: unset;
`;

export const ButtonContainer = styled(GridItem)`
  display: flex;
  justify-content: end;
  align-items: end;
  @media ${mediaSmallOrTiny} {
    justify-content: start;
  }
`;

// This component will be modified as the slider component is integrated
export const Slider = styled.div`
  display: flex;
  flex-direction: row;
  overflow: auto;
  padding: 22px;
  gap: 22px;
`;
